/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Team_Role_Marine_ConsultantInputs */



/**
* | output |
* | --- |
* | "Marine Consultant" |
*
* @param {Team_Role_Marine_ConsultantInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
export const team_role_marine_consultant = /** @type {((inputs?: Team_Role_Marine_ConsultantInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Team_Role_Marine_ConsultantInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return /** @type {LocalizedString} */ ("海事顾问")
	return /** @type {LocalizedString} */ ("Marine Consultant")
});